import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewPlan = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/common?table=plan`, data);
  return res.data;
};
export const getAllPlans = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/plan?start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
export const getRetailersById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/plans/${id}`);
  return res.data;
};
